var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "e-filters",
        {
          ref: "filters",
          attrs: {
            title: _vm.$t("Filtros"),
            searching: _vm.fetching,
            "show-search-button": false,
          },
          on: { reset: _vm.resetFilters },
          scopedSlots: _vm._u([
            {
              key: "after_buttons",
              fn: function () {
                return [
                  _c("e-button", {
                    staticClass: "ml-1 btn-sm-block",
                    attrs: {
                      id: "download",
                      variant: "primary",
                      icon: "download",
                      busy: _vm.fetching,
                      text: _vm.$t("Baixar Relatório"),
                    },
                    on: { click: _vm.downloadReport },
                  }),
                  _c("a", {
                    ref: "downloadLink",
                    staticStyle: { display: "none" },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("e-store-combo", {
                    attrs: { id: "filter-store", required: false },
                    model: {
                      value: _vm.filters.storeId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "storeId", $$v)
                      },
                      expression: "filters.storeId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "filter-motoboy",
                      type: "vue-select",
                      label: _vm.$t("Motoboy"),
                      placeholder: _vm.$t("Todos"),
                      options: _vm.getComboMotoboys,
                      disabled: !_vm.filters.storeId,
                    },
                    model: {
                      value: _vm.filters.motoboyId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "motoboyId", $$v)
                      },
                      expression: "filters.motoboyId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "filter-delivery-status",
                      type: "vue-select",
                      label: _vm.$t("Status da entrega"),
                      placeholder: _vm.$t("Todos"),
                      options: _vm.deliveryStatusOptions(),
                    },
                    model: {
                      value: _vm.filters.deliveryStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "deliveryStatus", $$v)
                      },
                      expression: "filters.deliveryStatus",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "filter-period",
                      type: "date-range-picker",
                      label: _vm.$t("Período"),
                      "time-picker": false,
                      validation: "required",
                    },
                    model: {
                      value: _vm.filters.period,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "period", $$v)
                      },
                      expression: "filters.period",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }